import Toast from '@ingka/toast'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAbTesting } from '@/contexts/abtesting-context/abtesting-context'
import { eventKeys } from '@/contexts/abtesting-context/optimizely-event-keys'
import { useAnalytics } from '@/hooks/use-analytics'
import { EVENT_LABEL_PRESELECT_UNIT } from '@/lib'
import { getPreselectedUnit } from '@/utils'

import { useStoresContext } from './stores-context'
import { useSelectedStores } from './use-selected-stores'

export function PreselectedStoreToast() {
  const { stores } = useStoresContext()
  const optimizely = useAbTesting()
  const { sendCustomEvent } = useAnalytics()
  const [toastVisible, setToastVisible] = useState(false)
  const { selectedStores, toggleStore } = useSelectedStores()
  const { t } = useTranslation()

  const getIkeaUnit = async (): Promise<string> => {
    let unitID = ''
    try {
      unitID = await getPreselectedUnit()
    } catch (error) {
      console.error(error)
    }
    return unitID
  }

  // only used to pre-select the unit
  useEffect(() => {
    if (!selectedStores.length) {
      getIkeaUnit()
        .then((unitID) => {
          const store = stores?.find(({ store_id }) => store_id === unitID)
          if (store) {
            toggleStore(store.store_id)
            setTimeout(() => setToastVisible(true), 500)
            optimizely.track(eventKeys.select_unit)
            optimizely.track(eventKeys.select_unit_automatically)
            void sendCustomEvent({
              event_label: EVENT_LABEL_PRESELECT_UNIT(store.name),
              event_action: store.name,
            })
          }
        })
        .catch(() => console.log('No pre-selected shop'))
    }
  }, [optimizely, selectedStores.length, sendCustomEvent, stores, toggleStore])

  if (!selectedStores[0]) return null

  return (
    <Toast
      text={t('common.store-automatically-selected', {
        storeName: t(`stores.${selectedStores[0].name}`, {
          defaultValue: selectedStores[0].name,
        }),
      })}
      isOpen={toastVisible}
      onCloseRequest={() => setToastVisible(false)}
      ariaLabelCloseBtn="Dismiss notification"
    />
  )
}
